//logo
import NC_1400x381 from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_1400x381.png';
import NC_2043x115 from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_2043x115.png';
import NC_1400x282 from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_1400x282.png';
import NC_1400x282_left from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_1400x282-left.png';
import NC_256x256 from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_256x256.png';
import NC_500x500 from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_500x500.png';
import NC_512x512 from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_512x512.png';
import NC_1024x1024 from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_1024x1024.png';
import NC_2043x119 from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_2043x119.png';
import NC_100x100_short_jpg from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_100x100_short_jpg.jpg';
import NC_100x100_short from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_100x100-short.png';
import NC_256x256_short from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_256x256_short.png';
import NC_512x512_short from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_512x512_short.png';
import NC_1024x1024_short from 'assets/images/ForInfluencersPage/Content/Images/logo/NC_1024x1024_short.png';
//arts
import miut_gutter_preview from 'assets/images/ForInfluencersPage/Content/Images/arts/miut_gutter_preview.png';
import miut_gutter from 'assets/images/ForInfluencersPage/Content/Images/arts/miut_gutter.jpg';
import rare_gnust_preview from 'assets/images/ForInfluencersPage/Content/Images/arts/rare_gnust_preview.png';
import rare_gnust from 'assets/images/ForInfluencersPage/Content/Images/arts/rare_gnust.png';
import uncommon_gnust_preview from 'assets/images/ForInfluencersPage/Content/Images/arts/uncommon_gnust_preview.png';
import uncommon_gnust from 'assets/images/ForInfluencersPage/Content/Images/arts/uncommon_gnust.png';
import common_gnust_preview from 'assets/images/ForInfluencersPage/Content/Images/arts/common_gnust_preview.png';
import common_gnust from 'assets/images/ForInfluencersPage/Content/Images/arts/common_gnust.png';
import mors_orless_preview from 'assets/images/ForInfluencersPage/Content/Images/arts/mors_orless_preview.png';
import mors_orless from 'assets/images/ForInfluencersPage/Content/Images/arts/mors_orless.jpg';
import freedom_gatia_logotype_preview from 'assets/images/ForInfluencersPage/Content/Images/arts/freedom_gatia_logotype_preview.png';
import freedom_gatia_logotype from 'assets/images/ForInfluencersPage/Content/Images/arts/freedom_gatia_logotype.png';
import miut_panorama_preview from 'assets/images/ForInfluencersPage/Content/Images/arts/miut_panorama_preview.png';
import miut_panorama from 'assets/images/ForInfluencersPage/Content/Images/arts/miut_panorama.png';
import miut_streets_preview from 'assets/images/ForInfluencersPage/Content/Images/arts/miut_streets_preview.png';
import miut_streets from 'assets/images/ForInfluencersPage/Content/Images/arts/miut_streets.jpg';
import NC_game_paths_preview from 'assets/images/ForInfluencersPage/Content/Images/arts/NC_game_paths-preview.png';
import NC_game_paths from 'assets/images/ForInfluencersPage/Content/Images/arts/NC_game_paths.png';
import gatia_space_view_preview from 'assets/images/ForInfluencersPage/Content/Images/arts/gatia_space_view_preview.png';
import gatia_space_view from 'assets/images/ForInfluencersPage/Content/Images/arts/gatia_space_view.jpg';
import fishlike_spaceship_preview from 'assets/images/ForInfluencersPage/Content/Images/arts/fishlike_spaceship_preview.png';
import fishlike_spaceship from 'assets/images/ForInfluencersPage/Content/Images/arts/fishlike_spaceship.png';
import spaceship_preview from 'assets/images/ForInfluencersPage/Content/Images/arts/spaceship-preview.png';
import spaceship from 'assets/images/ForInfluencersPage/Content/Images/arts/spaceship.png';
// gameplay screenshots
import equipment_preview from 'assets/images/ForInfluencersPage/Content/Images/screenshots/equipment_preview.png';
import equipment from 'assets/images/ForInfluencersPage/Content/Images/screenshots/equipment.jpg';
import levels_and_skills_preview from 'assets/images/ForInfluencersPage/Content/Images/screenshots/levels_and_skills_preview.png';
import levels_and_skills from 'assets/images/ForInfluencersPage/Content/Images/screenshots/levels_and_skills.jpg';
import players_inventory_preview from 'assets/images/ForInfluencersPage/Content/Images/screenshots/players_inventory_preview.png';
import players_inventory from 'assets/images/ForInfluencersPage/Content/Images/screenshots/players_inventory.jpg';
import nft_card_preview from 'assets/images/ForInfluencersPage/Content/Images/screenshots/nft_card_preview.png';
import nft_card from 'assets/images/ForInfluencersPage/Content/Images/screenshots/nft_card.jpg';
import place_of_work_preview from 'assets/images/ForInfluencersPage/Content/Images/screenshots/place_of_work_preview.png';
import place_of_work from 'assets/images/ForInfluencersPage/Content/Images/screenshots/place_of_work.jpg';
import training_battle_preview from 'assets/images/ForInfluencersPage/Content/Images/screenshots/training_battle_preview.png';
import training_battle from 'assets/images/ForInfluencersPage/Content/Images/screenshots/training_battle.jpg';
import battle_loading_preview from 'assets/images/ForInfluencersPage/Content/Images/screenshots/battle_loading_preview.png';
import battle_loading from 'assets/images/ForInfluencersPage/Content/Images/screenshots/battle_loading.jpg';
import battle_process_preview from 'assets/images/ForInfluencersPage/Content/Images/screenshots/battle_process_preview.png';
import battle_process from 'assets/images/ForInfluencersPage/Content/Images/screenshots/battle_process.jpg';
import battle_win_preview from 'assets/images/ForInfluencersPage/Content/Images/screenshots/battle_win_preview.png';
import battle_win from 'assets/images/ForInfluencersPage/Content/Images/screenshots/battle_win.jpg';

export type VisualTabKey = 'logos' | 'art' | 'gameplay_screenshots';
export type ImageCard = {
    title: string;
    preview: string;
    src: string;
};

export const imageCards: Record<VisualTabKey, ImageCard[]> = {
    logos: [
        {
            title: 'Neuroborn Cats logo 1400x381 px (png)',
            preview: NC_1400x381,
            src: NC_1400x381,
        },
        {
            title: 'Neuroborn Cats logo 2043x115 px (png)',
            preview: NC_2043x115,
            src: NC_2043x115,
        },
        {
            title: 'Neuroborn Cats logo 1400x282 px (png)',
            preview: NC_1400x282,
            src: NC_1400x282,
        },
        {
          title: 'Neuroborn Cats logo left align 1400x282 px (png)',
          preview: NC_1400x282_left,
          src: NC_1400x282_left,
        },
        {
            title: 'Neuroborn Cats logo 256x256 px (png)',
            preview: NC_256x256,
            src: NC_256x256,
        },
        {
            title: 'Neuroborn Cats logo 500x500 px (png)',
            preview: NC_500x500,
            src: NC_500x500,
        },
        {
            title: 'Neuroborn Cats logo 512x512 px (png)',
            preview: NC_512x512,
            src: NC_512x512,
        },
        {
            title: 'Neuroborn Cats logo 1024x1024 px (png)',
            preview: NC_1024x1024,
            src: NC_1024x1024,
        },
        {
            title: 'Neuroborn Cats logo 2043x119 px (png)',
            preview: NC_2043x119,
            src: NC_2043x119,
        },
        {
            title: 'Neuroborn Cats short logo 100x100 px (jpg)',
            preview: NC_100x100_short_jpg,
            src: NC_100x100_short_jpg,
        },
        {
            title: 'Neuroborn Cats short logo 100x100 px (png)',
            preview: NC_100x100_short,
            src: NC_100x100_short,
        },
        {
            title: 'Neuroborn Cats short logo 256x256 px (png)',
            preview: NC_256x256_short,
            src: NC_256x256_short,
        },
        {
            title: 'Neuroborn Cats short logo 512x512 px (png)',
            preview: NC_512x512_short,
            src: NC_512x512_short,
        },
        {
            title: 'Neuroborn Cats short logo 1024x1024 px (png)',
            preview: NC_1024x1024_short,
            src: NC_1024x1024_short,
        },
    ],
    art: [
        {
            title: 'Miut gutter (jpg)',
            preview: miut_gutter_preview,
            src: miut_gutter,
        },
        {
            title: 'Rare gnust (png)',
            preview: rare_gnust_preview,
            src: rare_gnust,
        },
        {
            title: 'Uncommon gnust (png)',
            preview: uncommon_gnust_preview,
            src: uncommon_gnust,
        },
        {
            title: 'Common gnust (png)',
            preview: common_gnust_preview,
            src: common_gnust,
        },
        {
            title: 'Mors Orless (jpg)',
            preview: mors_orless_preview,
            src: mors_orless,
        },
        {
            title: 'Freedom Gatia logotype (png)',
            preview: freedom_gatia_logotype_preview,
            src: freedom_gatia_logotype,
        },
        {
            title: 'Miut panorama (png)',
            preview: miut_panorama_preview,
            src: miut_panorama,
        },
        {
            title: 'Miut streets (jpg)',
            preview: miut_streets_preview,
            src: miut_streets,
        },
        {
            title: 'Neuroborn cats game paths (png)',
            preview: NC_game_paths_preview,
            src: NC_game_paths,
        },
        {
            title: 'Gatia space view (jpg)',
            preview: gatia_space_view_preview,
            src: gatia_space_view,
        },
        {
            title: 'Fishlike spaceship (png)',
            preview: fishlike_spaceship_preview,
            src: fishlike_spaceship,
        },
        {
            title: 'Spaceship (png)',
            preview: spaceship_preview,
            src: spaceship,
        },
    ],
    gameplay_screenshots: [
        {
            title: 'Equipment (jpg)',
            preview: equipment_preview,
            src: equipment,
        },
        {
            title: 'Levels and skills (jpg)',
            preview: levels_and_skills_preview,
            src: levels_and_skills,
        },
        {
            title: "Player's inventory (jpg)",
            preview: players_inventory_preview,
            src: players_inventory,
        },
        {
            title: 'NFT card (jpg)',
            preview: nft_card_preview,
            src: nft_card,
        },
        {
            title: 'Place of work (jpg)',
            preview: place_of_work_preview,
            src: place_of_work,
        },
        {
            title: 'Training battle (jpg)',
            preview: training_battle_preview,
            src: training_battle,
        },
        {
            title: 'Battle loading (jpg)',
            preview: battle_loading_preview,
            src: battle_loading,
        },
        {
            title: 'Battle process (jpg)',
            preview: battle_process_preview,
            src: battle_process,
        },
        {
            title: 'Battle win (jpg)',
            preview: battle_win_preview,
            src: battle_win,
        },
    ],
};